import { initialEnrollmentDetails, saveSession, useCaregiverWizardUpdateDispatch } from '../../../../ContextProviders/CaregiverWizard'
import { type PortalFacilityHours, type EnrollmentDetails, type ReferralTimeFrame } from '../../../../core/types'
import { useParams } from 'react-router'
import { useScrollTop } from '../../../../hooks/use-scrollTop'
import { ServiceProviderListSelect } from '../../Components/ServiceProviderListSelect'

interface ServiceProviderOption {
  id: number
  name: string
  subtext: string
  distance: string
  times: PortalFacilityHours[]
}

interface ServiceProviderSearchProps {
  caregiverForm: EnrollmentDetails
  maxProviders?: number
  handleStep: (backwards: boolean) => void
}

export function ServiceProviderSearch (props: ServiceProviderSearchProps): JSX.Element {
  const dispatch = useCaregiverWizardUpdateDispatch()
  const { isdId, isdServiceProviderId } = useParams()
  const caregiverForm = props.caregiverForm
  const currentService = caregiverForm.currentChild.requestedServices?.find(s => s.isCurrentlyUpdating)
  const serviceId = currentService?.id

  useScrollTop()

  const handleBack = async (): Promise<void> => {
    const tempForm = { ...caregiverForm, currentStep: 3, currentSubStep: 3 }
    await saveSession(tempForm)
    props.handleStep(true)
    dispatch({ type: 'form', form: tempForm })
  }

  const handleContinue = async (selectedProviders: ServiceProviderOption[]): Promise<void> => {
    if (props.maxProviders !== undefined && selectedProviders.length > props.maxProviders) {
      return
    }

    const tempForm = { ...caregiverForm, currentSubStep: 3 }
    const tempChild = { ...tempForm.currentChild }
    const currentService = tempChild.requestedServices?.find(s => s.isCurrentlyUpdating)
    if (currentService != null) {
      currentService.facilityIds = selectedProviders.map(p => p.id)
    }
    const existingChildIndex = tempForm.children.findIndex(c => c.isCurrentlyUpdating)
    if (existingChildIndex !== -1) {
      tempChild.isCurrentlyUpdating = false
      const service = tempChild.requestedServices?.find(s => s.isCurrentlyUpdating)
      if (service != null) {
        service.isCurrentlyUpdating = false
      }
      tempForm.children[existingChildIndex] = tempChild
    }
    const initialForm = initialEnrollmentDetails()
    tempForm.currentChild = initialForm.currentChild

    await saveSession(tempForm)
    dispatch({ type: 'form', form: tempForm })
  }

  const handleMapClick = async (): Promise<void> => {
    const tempForm = { ...caregiverForm, currentSubStep: 2 }
    await saveSession(tempForm)
    dispatch({ type: 'form', form: tempForm })
  }
  const srvs = props.caregiverForm.currentChild.requestedServices
  let rtf: ReferralTimeFrame | null = null
  if (srvs != null && srvs?.length > 0) {
    rtf = srvs[0].timeFrame
  }

  return <ServiceProviderListSelect childDOB={caregiverForm.currentChild.dateOfBirth} timeFrame={rtf} childLocation={caregiverForm.currentChild.location} isdId={Number(isdId)}
    serviceId={serviceId ?? 0} isdServiceProviderId={Number(isdServiceProviderId)} handleBack={handleBack} handleContinue={handleContinue} handleMapSelectionClick={handleMapClick} maxProviders={props.maxProviders}
  />
}
